<template>
  <div>
    <el-dialog
      v-if="info"
      title="查看认证信息"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="onHandleClose"
      width="40%"
      class="DetailsDialog"
      center
    >
      <div>
        <div class="list-item">
          <div class="list-item-left">认证类型：</div>
          <div class="list-item-right">{{ info.certification_type_txt }}</div>
        </div>
        <div class="list-item">
          <div class="list-item-left">统一社会信息码：</div>
          <div class="list-item-right">{{ info.uscc }}</div>
        </div>
        <div class="list-item">
          <div class="list-item-left">营业执照：</div>
          <div class="list-item-right">
            <el-image
              style="width: 100px; height: 100px"
              :src="info.license.img"
             
              :preview-src-list="[info.license.img]"
            >
             <div slot="error" class="image-slot">
       暂无数据
      </div>
            </el-image>
          </div>
        </div>
        <div class="list-item">
          <div class="list-item-left">{{info.certification_type != 10 ? '法人姓名：' : '持卡人姓名：'}}</div>
          <div class="list-item-right">{{ info.idcard_name }}</div>
        </div>
        <div class="list-item">
          <div class="list-item-left">   {{ info.certification_type != 10
                ? '法人身份证号：'
                : '持卡人身份证号：' }}</div>
          <div class="list-item-right">{{ info.idcard_code }}</div>
        </div>
        <div class="list-item">
          <div class="list-item-left">{{info.certification_type != 10 ? '法人手机号码：' : '银行预留电话：'}}</div>
          <div class="list-item-right">{{ info.manage_mobile }}</div>
        </div>
        <div class="list-item">
          <div class="list-item-left"> {{info.certification_type != 10 ? '法人身份证国徽页：' : '持卡人身份证国徽页：'}}</div>
          <div class="list-item-right">
            <el-image
              style="width: 100px; height: 100px"
              :src="info.idcard_a"
              :preview-src-list="[info.idcard_a]"
              
            >
             <div slot="error" class="image-slot">
       暂无数据
      </div>
            </el-image>
          </div>
        </div>
        <div class="list-item">
          <div class="list-item-left"> {{info.certification_type != 10 ? '法人身份证人像页：' : '持卡人身份证人像页：'}}</div>
          <div class="list-item-right">
            <el-image
              style="width: 100px; height: 100px"
               :src="info.idcard_b"
              :preview-src-list="[info.idcard_b]"
               alt=""
            >
             <div slot="error" class="image-slot">
       暂无数据
      </div>
            </el-image>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onHandleClose">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "DetailsDialog",
  props: {},
  data() {
    return {
      dialogVisible: false,
      info: "",
    };
  },
  methods: {
    /**
     * 初始化
     */
    onInitData(data) {
      this.info = data;
      this.dialogVisible = true;
    },

    /**
     * 关闭操作
     */
    onHandleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.DetailsDialog {
     .DetailsDialog-cnt{
        height: 500px;
        overflow-y: auto;
    }
  .list-item {
    display: flex;
    align-items: center;
    
    .list-item-left {
        font-size: 24px;
        color: #000;
    }
    .list-item-right {
        font-size: 24px;
        .el-image{
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
  }
}
</style>
